import React from 'react';

// Privacy Policy Component
const Privacy = () => {
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
          <p className="text-gray-600">Effective date: January 1, 2024</p>
        </div>

        <div className="prose prose-gray max-w-none">
          <p className="text-gray-700 leading-relaxed mb-6">
            This privacy policy (the "Privacy Policy"), together with the terms of use, describes the Aashritha e Solutions policies and procedures on the collection, use and disclosure of the information provided by Users (as defined herein below) of the Scheme App "App". Every User who accesses or uses the App shall be bound by this Privacy Policy.
          </p>

          <p className="text-gray-700 leading-relaxed mb-6">
            The Privacy Policy explains how Aashritha e Solutions may collect, use, and disclose information we obtain through the App. All other terms not defined herein will have the meanings set forth in the Terms of Use.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Information We Collect</h2>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Personal Information</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            "Personal Information" means information that alone or when in combination with other information may be used to readily identify, contact, or locate you, such as: name, address, email address, or phone number. We do not consider Personal Information to include information that has been anonymized so that it does not allow a third party to easily identify a specific individual. We do not collect Personal Information from you unless you voluntarily provide it to us.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Non-Personal Information</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            "Non-Personal Information" means information that does not identify any individual, including without limitation IP type, IP host address, ISP address, cookie IDs and segment IDs associated with cookie IDs, pages viewed and/or search terms entered, browser type, operating system, duration and frequency of visits, anonymous usage statistics including frequency of messaging and interaction with other users, clickstream data other log file data, or social analytics and tracking measurements. On mobile devices, we may also collect device type, make and model, operating system, carrier, user ID, similar device IDs, and information about the apps you use.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Collection of Information</h2>
          <p className="text-gray-700 leading-relaxed mb-4">We collect Personal Information when you choose to provide it to us including when you:</p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>register to use the App;</li>
            <li>use the App; and</li>
            <li>communicate with us.</li>
          </ul>

          <p className="text-gray-700 leading-relaxed mb-4">
            We also collect Non-Personal Information, by using cookies, pixels, server logs, and other similar technology as you use the App. Please note that we may use third party service providers to help operate the App and these third party service providers will collect Non-Personal Information from our App as well.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Personal Information Collection</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            When you purchase a product, you must provide us with Personal Information, such as your name, email address, phone number, address etc.
          </p>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Communications with Us</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            We may also collect Personal Information from you when you choose to communicate with us. For example, you may choose to send us Personal Information in an email to us, when signing up for an account, newsletter or other service. By providing your email address to us, you expressly consent to receive emails from us. We may use email to communicate with you, to send information that you have requested or to send information about other products or services developed or provided by us or our partners, provided that, we will not give your email address to another party to promote their products or services directly to you without your consent. If you contact us, we may keep a record of that correspondence.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">How We Use Your Information</h2>
          <p className="text-gray-700 leading-relaxed mb-4">We use Personal Information to:</p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>facilitate and improve our services; and</li>
            <li>communicate with you.</li>
          </ul>

          <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Provide Services to You</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            We may use aggregate information for any purpose, including for marketing purposes. Internal and Service-Related Usage. We use information, including Personal Information, for internal and service-related purposes only and may provide it to third parties to allow us to facilitate the App. We may use and retain any data we collect to provide and improve our services. We may also use such data to help us deliver targeted advertising to Users, to analyse interactions with and performance of our App, measure the effectiveness of advertising on behalf of our advertising partners, and to identify the audience most likely to respond to an advertisement.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">How We Share Your Information</h2>
          <p className="text-gray-700 leading-relaxed mb-4">We may share your information:</p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li>with our third-party service providers;</li>
            <li>to comply with legal obligations;</li>
            <li>to protect and defend our rights and property; and</li>
            <li>with your permission.</li>
          </ul>

          <p className="text-gray-700 leading-relaxed mb-4">
            We do not rent, sell, or share Personal Information about you with other people or non-affiliated companies for their direct marketing purposes, unless we have your permission.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Security</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            We take steps to ensure that your information is treated securely and in accordance with this Privacy Policy. Unfortunately, the Internet cannot be guaranteed to be 100% secure, and we cannot ensure or warrant the security of any information you provide to us. We do not accept liability for unintentional disclosure.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Changes to This Privacy Policy</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            We may revise this Privacy Policy without prior notice, so review it periodically. If you continue to visit this App and use the services made available to you after such changes have been made, you hereby provide your consent to the changes.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Us</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            In accordance with IT Act and rules made there under, the name and contact details of the Grievance Officer are provided below:
          </p>
          <div className="bg-gray-50 p-4 rounded border-l-4 border-blue-500 mb-6">
            <p className="text-gray-700 mb-1"><strong>Name:</strong> Mr. Srinivas U.B</p>
            <p className="text-gray-700 mb-1"><strong>Phone:</strong> +91 9448128756</p>
            <p className="text-gray-700"><strong>Email:</strong> aashritha756@yahoo.com</p>
          </div>
        </div>
      </div>
    </div>
  );
};


export default Privacy;
